<template>
    
    <div class="local-material-page">

        <a-spin :tip="'素材下载中，请勿刷新页面...' " size="large" :spinning="materialLoading">
            <template>
                <div class="table-operator">
                    <!-- 操作按钮行 -->
                    <div class="button-row">
                        <a-space>
                            <!-- <a-button size="small" icon="plus" @click="createFolder" v-if="accessTo('store')">新建素材组</a-button>

                            <a-button size="small" type="primary" icon="cloud-upload" @click="create($event, 'create')"
                                v-if="accessTo('store')">上传素材</a-button>
                            <a-button size="small" type="primary" icon="cloud-upload" @click="showBatchUpload=true"
                                v-if="accessTo('store')">批量上传</a-button>
                            <a-button size="small" type="primary" icon="import" @click="importMaterial($event)"
                                v-if="accessTo('import')">导入素材</a-button> -->

                            <a-button size="small" type="primary" icon="cloud-upload" @click="uploadToKuaishou($event, 'create')" v-if="accessTo('uploadToMedia') ">直传快手</a-button>
                            <!-- <a-button size="small" type="primary" icon="cloud-upload" @click="uploadToJuliang($event, 'create')" v-if="accessTo('uploadToMedia') ">直传巨量</a-button>
                            <a-button size="small" type="primary" @click="clickJuliang()">切入邮箱</a-button>

                            <a-button size="small" icon="unordered-list" @click="openPushRecords">推送记录</a-button> -->

                            <a-button size="small" @click="selectAll" :loading="selecting">全选</a-button>

                            <a-dropdown  :disabled="selectedIds.length === 0" v-if="!filters || !filters.type || !filters.isBatchSelect">
                                <a-menu slot="overlay">
                                    <a-menu-item key="1" @click="downloadMaterial"  v-if="accessTo('download')"><a-icon type="download" />
                                        下载
                                    </a-menu-item>
                                    <a-menu-item key="2" v-if="accessTo('destroy') && canDel" ><a-icon type="delete" />
                                        <a-popconfirm title="确认要批量删除吗?" @confirm="destroy()" >
                                            删除
                                        </a-popconfirm>
                                    </a-menu-item>
                                    <a-menu-item key="3" @click="create($event, null,'copy')"  v-if="accessTo('update')"><a-icon type="copy" />
                                        复制
                                    </a-menu-item>
                                    <a-menu-item key="8" @click="createZm($event)"  v-if="accessTo('zmTask')"><a-icon type="copy" />
                                        转码
                                    </a-menu-item>
                                    <a-menu-item key="4" @click="create($event, null,'move')"  v-if="accessTo('update')"><a-icon type="scissor" />
                                        移动
                                    </a-menu-item>
                                    <a-menu-item key="5" @click="uploadToMedia(1)"  v-if="accessTo('uploadToMedia')"><a-icon type="cloud" />
                                        同步到巨量
                                    </a-menu-item>
                                    <a-menu-item key="7" @click="uploadToMedia(1,1)"  v-if="accessTo('uploadToMedia')"><a-icon type="cloud" />
                                        同步到快手
                                    </a-menu-item>
                                    <a-menu-item key="13" @click="uploadToMedia(4,1)"  v-if="accessTo('uploadToMedia')"><a-icon type="cloud-upload" />
                                        同步到快手(本地上传)
                                    </a-menu-item>
                                    <a-menu-item key="6" @click="uploadToMedia(2)"  v-if="accessTo('uploadToMedia')"><a-icon type="cloud" />
                                        推送到巨量媒体
                                    </a-menu-item>
                                    <a-menu-item key="11" @click="uploadToMedia(2, 1)"  v-if="accessTo('uploadToMedia')"><a-icon type="cloud" />
                                        推送到快手媒体
                                    </a-menu-item>
                                    <a-menu-item key="12" @click="syncToOrganization()"  v-if="accessTo('uploadToMedia')"><a-icon type="cloud" />
                                        同步到巨量组织
                                    </a-menu-item>
                                    <a-menu-item key="9" @click="createAdTask(1)"  v-if="accessTo('createAdTask')"><a-icon type="cloud" />
                                        创建计划
                                    </a-menu-item>
                                </a-menu>
                                <a-button size="small"> 批量 <a-icon type="down" /></a-button>
                            </a-dropdown>
                        </a-space>
                    </div>

                    <!-- 搜索筛选行：独立一行，放在操作按钮下方 -->
                    <div class="search-wrapper2">
                        <a-space :wrap="true">
                            <a-button  icon="select" type="primary" @click="batchChoiceMaterial()" :disabled="selectedIds.length === 0" v-if="!(!filters || !filters.type || !filters.isBatchSelect)">批量选择素材</a-button>

                            <!-- 磁盘来源筛选：source_server 1=磁盘2(playlet-material-new), 2=磁盘1(playlet-material) -->
                            <a-select allow-clear placeholder="磁盘来源" v-model="queryParam.source_server">
                                <a-select-option :value="2">磁盘1</a-select-option>
                                <a-select-option :value="1">磁盘2</a-select-option>
                            </a-select>

                            <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
                                <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                                  {{ corporation.name }}
                                </a-select-option>
                            </a-select>
                            <a-select allow-clear placeholder="素材类型" v-model="queryParam.material_type" show-search option-filter-prop="children">
                                <a-select-option :value="item.id" v-for="item in types" :key="item.id" >
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                            <a-select allow-clear placeholder="上传人" v-model="queryParam.admin_id" show-search option-filter-prop="children">
                                <a-select-option :value="item.id" v-for="item in uploaders" :key="item.id" >
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>

                            <a-input allow-clear placeholder="名称" v-model="queryParam.name" />
                            <a-date-picker placeholder="上传日期" 
                                :default-value="queryParam.upload_day"
                                v-model="queryParam.upload_day"
                                valueFormat="YYYY-MM-DD"
                                :allowClear="true"
                            />

                            <a-button type="primary" @click="search">查询</a-button>
                            <a-button @click="resetSearch">重置</a-button>
                        </a-space>
                    </div>
                </div>
   
                <a-breadcrumb style="margin:5px 20px 5px 25px;" >
                    <a-breadcrumb-item v-for="item in breadcrumb" :key="item.id" >
                        <span @click="clickBreadcrumb(item)" style="cursor: pointer;">
                            <a-icon type="folder"/> {{item.name}}
                        </span>
                    </a-breadcrumb-item>
                  </a-breadcrumb>
            
                  
                <template>
                    <div class="content">
                        <a-tabs :default-active-key="tabIndex.toString()" @change="tabClick" ref="tabs" :activeKey="tabIndex.toString()" >
                            <a-tab-pane key="1" tab="素材组管理"></a-tab-pane>
                            <a-tab-pane key="2" tab="素材管理" force-render></a-tab-pane>
                        </a-tabs>

                        <a-row type="flex" :pagination="pagination">
                            <a-col v-if="tabIndex == 1" :span="4" class="directory-tree">
                                <!-- <a-directory-tree @select="onSelect" :tree-data="treeData"
                                    :replace-fields="replaceFields" /> -->
                                <!-- 搜索框 -->
                                <a-input-search
                                    placeholder="搜索目录"
                                    allow-clear
                                    v-model="dirSearch"
                                    @input="filterTree"
                                    style="margin-bottom: 8px"
                                />
                                <!-- 树 -->
                                <a-directory-tree
                                    @select="onSelect"
                                    :tree-data="filteredTreeData.length ? filteredTreeData : treeData"
                                    :replace-fields="replaceFields"
                                    :expandedKeys="expandedKeys"
                                    :autoExpandParent="true"
                                    @expand="expandedKeys = $event"
                                />
                            </a-col>

                            <a-col :span="tabIndex == 1 ? 20 : 24" style="margin-left:15px" >

                                <template>
                                    <a-list  :grid="{ gutter: 16, xs: 6, }" :data-source="data" :pagination="pagination" 
                                        :transform-cell-text="$helper.emptyFormat">
                                        <a-list-item slot="renderItem" slot-scope="item" >
                                            <!-- <a-card hoverable class="card-container" @click="handleCheckboxChange(item)"> -->
                                            <a-card hoverable class="card-container" :class="{ 'disabled-card': isDisabled(item) }" @click="handleCheckboxChange(item)">
                                               <!-- 添加复选框 -->
                                               <a-checkbox v-if="showSelect(item)"  class="checkbox" :checked="selectedIds.includes(item.id)" />
                                                <div  class="content-material">
                                                    <!-- 磁盘来源角标：仅对非文件夹素材展示，1=磁盘2, 2=磁盘1 -->
                                                    <div class="disk-badge" v-if="item.type != 1 && item.source_server">
                                                        <a-icon type="database" />
                                                        <span>{{ item.source_server == 1 ? '磁盘2' : '磁盘1' }}</span>
                                                    </div>
                                                    <div v-if="item.type == 1" @click="clickFolder($event, item)"  class="content-material-folder" >
                                                        <template v-if="item.covers.length > 0">
                                                            <a-col :span="1" v-for="(img, index) in item.covers"
                                                                :key="index"
                                                                class="content-material-folder-col" >
                                                                <img v-if="img" :src="img" />
                                                                <div v-else style="text-align:center;font-size:35px;color:#f2bf65">
                                                                    <a-icon type="folder" theme="filled" />
                                                                </div>
                                                            </a-col>
                                                        </template>
                                                        <a-empty v-else :image="simpleImage" style="margin-left:-50px" />
                                                    </div>

                                                    <div class="content-material-iv" v-else>
                                                        <img @click="clickMaterial($event, item)" v-if="item.type == 2" style="height:140px"
                                                        :src="item.file_url" />

                                                        <template v-else-if="item.type == 3" >
                                                            <img style="height:140px" @click="clickMaterial($event, item)" :src="item.video_cover" />
                                                                <a-icon type="play-circle"  @click="clickMaterial($event, item)" class="play-icon" />
                                                        </template>
                                                    </div>
                                                    
                                                </div>

                                                <div style="margin-top:17px;min-height:25px" >
                                                    <a-tag color="cyan" v-if="item.type == 1">
                                                        <a-icon type="folder-open" />文件夹
                                                    </a-tag>

                                                    <a-tag color="blue" v-else>
                                                        <a-icon type="rocket" />上传人：
                                                        <span v-if="item.worker_name">{{ item.worker_name }}</span>
                                                        <span v-else>{{ item.admin_name }}</span>
                                                    </a-tag>
                                                </div>
                                              

                                                <template slot="actions"  v-if="!filters.type">
                                                    <a-tooltip title="复制" @click="create($event, item,'copy')" v-if="accessTo('update')">
                                                        <a-icon key="copy" type="copy" />
                                                    </a-tooltip>
                                                    <a-tooltip title="移动"  @click="create($event, item,'move')" v-if="accessTo('update')">
                                                        <a-icon type="scissor" />
                                                    </a-tooltip>
                                                    
                                                    <a-tooltip title="编辑" @click="create($event, item)" v-if="accessTo('update')">
                                                        <a-icon key="edit" type="edit" />
                                                    </a-tooltip>

                                                    <a-tooltip v-if="item.type === 2" title="裁剪" @click="clickCropper($event, item)" >
                                                        <a-icon type="file-add" />
                                                    </a-tooltip>
                                                    
                                                    <a-tooltip v-if="accessTo('mediaRecord') && item.type === 3" title="同步到媒体" @click="clickMediaRecord($event, item)" >
                                                        <a-icon type="cloud" />
                                                    </a-tooltip>

                                                    <a-popconfirm title="确认要删除吗?" @confirm="destroy(item)" v-if="accessTo('destroy') && canDel">
                                                        <a-icon key="delete" type="delete" />
                                                    </a-popconfirm>

                                                  
                                                </template>

                                                <template slot="actions" v-else-if="item.type!=1 &&  filters.type == item.type">
                                                    <a-tooltip title="选择" @click="choiceMaterial(item)" style="fontSize:13px;color:#2db7f5" v-if="!(filters && filters.isBatchSelect)">
                                                        <a-icon type="upload"/> 选择素材
                                                    </a-tooltip>
                                                    <a-tooltip v-if="item.type === 2" title="裁剪" @click="clickCropper($event, item)" style="fontSize:13px;color:#2db7f5">
                                                        <a-icon type="file-add" /> 剪裁
                                                    </a-tooltip>
                                                </template>

                                                <template slot="actions" v-else>
                                                   <div> &nbsp;&nbsp;&nbsp;&nbsp;</div>
                                                    <!-- <div style="height:19px;"></div> -->
                                                </template>

                                                <a-tooltip :title="item.name">
                                                   <a-card-meta :title="item.name" />
                                                </a-tooltip>

                                                <div  class="video_sync_tag">
                                                    <a-tag color="red" v-if="item.type !=1 && item.size/1024/1024>1000">超大素材</a-tag>
                                                    <a-tag color="green" v-if="item.type === 3  && item.madia_record && item.madia_record.media === 2 && item.madia_record  && item.madia_record.status == 2">已同步巨量</a-tag>
                                                    <a-tag color="red" v-else-if="item.type === 3 && item.checked!=1">{{item.id}}验证文件完整性中</a-tag>
                                                    <a-tag color="red" v-else-if="item.type === 3 && filters && filters.need_sync_juliang === true && !(item.madia_record  && item.madia_record.status == 2)">请先同步到巨量</a-tag>
                                                </div>
                                                
                                                <div  class="tag3">
                                                    <a-tag color="green" v-if="item.type === 3 && item.madia_kuaishou_record  && item.madia_kuaishou_record.media === 1 && item.madia_kuaishou_record  && item.madia_kuaishou_record.status == 2">已同步快手</a-tag>
                                                </div>

                                                <div  class="tag4">
                                                    <a-tag color="purple" v-if="item.type === 3 && item.madia_org_record && item.madia_org_record.status == 2">已同步巨量组织</a-tag>
                                                </div>

                                                <div  class="tag2">
                                                    <a-tag color="red" v-if="item.reject_reason && item.reject_reason.id" @click="clickMaterial($event, item, 2)">素材审核建议</a-tag>
                                                </div>

                                                <div  class="tag1">
                                                    <a-tag color="green" v-if="item.is_zm == 1 ">已转码</a-tag>
                                                </div>
                                              
                                            </a-card>
                                        </a-list-item>
                                    </a-list>

                                  
                                    <a-button size="small" type="primary" icon="hourglass" @click="showTask()"
                                    v-if="accessTo('showTask') && pid>0">查看当前目录下的导入素材任务进度</a-button>

                                    <a-popconfirm  v-if="accessTo('clearFolders') && isTrash" title="确认要清空垃圾站吗?" @confirm="clearFolder()">
                                        <a-button size="small" type="danger" icon="delete" style="margin-left: 8px">一键清空垃圾站</a-button>
                                    </a-popconfirm>
                                </template>

                            </a-col>
                        </a-row>

                    </div>
                </template>

            </template>

        <create-form v-if="showForm" :showForm.sync="showForm" :model="model" @success="refresh" />
        <import-material-form v-if="showImportForm" :showImportForm.sync="showImportForm" :model="model" @success="refresh" />
        <task-page :showTaskPage.sync="showTaskPage" :model="taskModel" @success="refresh" />

        <create-folder-form v-if="showFolderForm" :showFolderForm.sync="showFolderForm" :model="model" @success="refresh" />
        <create-zm-form v-if="showZmForm" :showZmForm.sync="showZmForm" :model="model" @success="refresh" />

        <a-drawer placement="right" :closable="false" :visible="previewVisible" @close="previewCancel"  :width="720" :body-style="{ paddingBottom: '80px' }">
           
            <template v-if="preview.show_reject_reason">
                <a-form-model-item label="拒绝原因" >
                    <div v-for="item in preview.reject_reason.reject_reason" :key="item.id">
                        {{ item }}
                    </div>
                </a-form-model-item>

                <a-form-model-item label="建议" >
                    <div v-for="item in preview.reject_reason.suggestion" :key="item.id">
                        {{ item }}
                    </div>
                </a-form-model-item>

            </template>
         
           
            <template v-else>
                <a-form-model-item :label="preview.name">
                    <video v-if="preview.type == 3 && previewVisible" controls style="width:70%" :src="preview.file_url"  ref="video" controlslist="nodownload noremoteplayback"/>
                    <img v-else alt="example" style="width: 60%" :src="preview.file_url" />
                </a-form-model-item>
    
                <a-form-model-item label="上传人">
                    <a-tag color="blue" v-if="preview.worker_name">
                        {{ preview.worker_name }}
                    </a-tag>
                    <a-tag color="blue" v-else>
                        {{ preview.admin_name }}
                    </a-tag>
                </a-form-model-item>
    
                <a-form-model-item label="素材标签">
                    <a-tag color="blue" v-for="item in preview.materialTags" :key="item.id">
                        {{ item.name }}
                    </a-tag>
                </a-form-model-item>
    
                <a-form-model-item label="备注">
                    <a-textarea v-model="preview.remark" placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" disabled/>
                </a-form-model-item>
            </template>
           

       </a-drawer>



       <cropper-page v-if="showCropper" :showCropper.sync="showCropper" :model="model" @success="refresh"  />
       <media-record-page v-if="showMediaRecordPage" :showMediaRecordPage.sync="showMediaRecordPage" :model="model" @success="getMaterials" />

       <media-record-create-form v-if="showUploadForm" :showUploadForm.sync="showUploadForm" :model="model" @success="getMaterials" />

       <create-ad-task-form v-if="showCreateAdTaskForm" :showCreateAdTaskForm.sync="showCreateAdTaskForm" :model="model" @success="getMaterials" />
      
       <kuaishou-upload
        v-if="showUpload"
        :showUpload.sync="showUpload"
        :model="model"
        media="kuaishou"
        @success="refresh"
        />

          
       <juliang-upload
       v-if="showJuliangUpload"
       :showJuliangUpload.sync="showJuliangUpload"
       :model="model"
       media="juliang"
       @success="refresh"
       />

       <jump-juliang-page
        v-if="showJumpJuliangPage"
        :showJumpJuliangPage.sync="showJumpJuliangPage"
        :model="jumpJuliangModel"
        />

       <sync-to-organization
        v-if="showSyncToOrganization"
        :showForm.sync="showSyncToOrganization"
        :model="syncOrgModel"
        @success="refresh"
        />

       <push-records-modal
        v-if="showPushRecords"
        :showPushRecords.sync="showPushRecords"
        />

       <batch-upload
        v-if="showBatchUpload"
        :showBatchUpload.sync="showBatchUpload"
        :defaultPid="pid"
        @success="refresh"
        />

        </a-spin>

        <!-- 悬浮统计插件（已隐藏） -->
        <div v-if="false" class="floating-stats-box" ref="floatingStatsBox" @mousedown="startDrag">
            <div class="disk-row">
                <!-- 磁盘1 -->
                <div class="disk-item">
                    <a-progress type="circle" :width="80" :percent="diskCapacity.percent" :strokeColor="getDiskColor(diskCapacity.percent)" :format="percent => `${percent}%`" />
                    <div style="margin-top: 8px; text-align: center; font-size: 12px;">
                        磁盘1：{{ diskCapacity.used }} / {{ diskCapacity.total }} {{diskCapacity.unit}}
                    </div>
                </div>
                <!-- 磁盘2 -->
                <div class="disk-item">
                    <a-progress type="circle" :width="80" :percent="diskCapacity2.percent" :strokeColor="getDiskColor(diskCapacity2.percent)" :format="percent => `${percent}%`" />
                    <div style="margin-top: 8px; text-align: center; font-size: 12px;">
                        磁盘2：{{ diskCapacity2.used }} / {{ diskCapacity2.total }} {{diskCapacity2.unit}}
                    </div>
                </div>
            </div>
            <div class="refresh-btn">
                <a href="#" @click.prevent="getDiskInfo()">刷新</a>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import 'LocalMaterial';
</style>

<script>
import LocalMaterial from './LocalMaterial'
export default LocalMaterial
</script>
